export const getRandomEntry = <T>(arr: T[]): T | undefined => {
    if (arr.length === 0) return undefined;
    const index = Math.floor(Math.random() * arr.length);
    return arr[index];
};

/**
 * Creates a promise that resolves after a random delay between min and max seconds
 * @param min Minimum delay in seconds (defaults to 1)
 * @param max Maximum delay in seconds (defaults to 3)
 * @returns Promise that resolves after the random delay
 */
export const waitRandom = (min = 1, max = 2): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, min * 1000 + Math.random() * (max - min) * 1000));
